import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const fetchGames = async () => {
  const { data } = await client.get(`/games`);
  return data.games;
};

export const fetchDaily = async (difficulty, dateStr) => {
  const params = { difficulty };
  if (dateStr) params.date = dateStr;
  const { data } = await client.get(`/puzzle/daily`, { params });
  return data;
};

export const fetchEndless = async (difficulty) => {
  const { data } = await client.get(`/puzzle/endless`, { params: { difficulty } });
  return data;
};

export const fetchStats = async (deviceId) => {
  const { data } = await client.get(`/stats/${deviceId}`);
  return data;
};

export const postComplete = async (payload) => {
  const { data } = await client.post(`/stats/complete`, payload);
  return data;
};
